import { render, staticRenderFns } from "./chooseTemplate.vue?vue&type=template&id=8d722790&"
import script from "./chooseTemplate.vue?vue&type=script&lang=js&"
export * from "./chooseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./chooseTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports